import React from 'react';
// @ts-ignore
import Config from 'Config';
import StripeContainer from 'components/StripeContainer';

type Props = {
  children: React.ReactNode;
};

export default function AdminUpgradePlanStripeContainer(props: Props) {
  return (
    <StripeContainer apiKey={Config.Environment.SAAS_STRIPE_KEY}>
      {props.children}
    </StripeContainer>
  );
}
